import React, { useState } from "react";
import { useSelector } from "react-redux";
import SideNavigation from "../../Menu-sidenavbar/SideNavigation ";
import { useNavigate } from "react-router-dom";
import HeaderBackground from "../../../common/SubpagesBGimage";
import { useLocation } from "react-router-dom";
function Statutorycommitte() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const location = useLocation();
  document.title = "Statutory Committee | PSG-IAP";
  const routeNames = {
    "/about-us/statutory-committee": {
      menuName: "About Us",
      subMenuName: "Statutory Committee",
    },
  };

  const { StatutoryCommittee } = useSelector(
    (state) => state?.StatutoryCommitteeReducer
  );
  const committees = StatutoryCommittee?.committee || [];
 const committeeContent =
    StatutoryCommittee?.statutory_committee?.[0]?.committee_content || "";
  // Navigate to the route of the static component
  const handleCommitteeClick = (committeeName) => {
    const slugify = (text) =>
      text
        .toLowerCase()
        .replace(/[’']/g, "")
        .replace(/&/g, "and")
        .replace(/\s+/g, "-");

    navigate(`/about-us/statutory-committee/${slugify(committeeName)}`);
  
  };

  return (
    <div>
      {/* Header */}
      <HeaderBackground
        menuName="About Us"
        subMenuName="Statutory Committee"
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />

        <div className="statutory">
        <div className="container statutorycommittee">
          <div className="mb-60">
          <h1 className="submenu-heading-text statutory-comm fw-400 heading-submenu-res overall-submenu-heading">Statutory Committee</h1>
            <div className="bord pt-25  d-flex align-items-center flex-md-wrap">
              <div className="statutorycommittee1">
                {/* <h4 className="fw-600 text-u ls1 sct">
                  Institutional{" "}
                  <span className="fw-200 committee-text">Committees</span>
                </h4> */}
              </div>
              <div className="committee-center">
                <p className="committee-center-para">
                  <div className="committee-center-para1">{committeeContent}</div>
                </p>
              </div>
            </div>
          </div>
        </div>

        
          <div className="container">
            <div className="buttons mb-60 cards-space-res">
              {committees.map((committee) => (
                <button
                  key={committee.id}
                  className="neumorphic stat-cards"
                  onClick={() =>
                    handleCommitteeClick(committee.committee_name)
                  }
                >
                  <img
                    src={committee.pdf}
                    alt={committee.committee_name || "Committee Image"}
                    className="images-stat"
                  />
                  <span>{committee.committee_name}</span>
                </button>
              ))}
            </div>
          </div>
        
      </div>

      {/* Side Navigation */}
      <SideNavigation
        key="About Us"
        isMenuOpen={isMenuOpen}
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        defaultOpenSubMenu="About Us"
      />
    </div>
  );
}

export default Statutorycommitte;
